import React from "react";
import { Link } from "react-router-dom";
import {
  Users,
  CheckCircle,
  Palette,
  Layout,
  Target,
  ExternalLink,
} from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DesignUXUI = () => {
  return (
    <div className="font-sans min-h-screen bg-gray-50">
      <Header />

      {/* Hero Section */}
      <section className="relative min-h-[500px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url(/images/design-ui/2149930986.jpg)" }}
        ></div>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black to-flowkraft-primary opacity-90"></div>

        <div className="container mx-auto px-4 relative z-10 py-20">
          <div className="flex items-center justify-center mb-8">
            <Users className="w-16 h-16 text-flowkraft-secondary" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 text-white">
            Design UX/UI
          </h1>
          <p className="text-xl text-center text-gray-200 max-w-3xl mx-auto">
            Conception d'expériences utilisateur innovantes et interfaces
            intuitives
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Design Centré Utilisateur
          </h2>
          <p className="text-lg text-gray-700 mb-4">
            Nous créons des expériences digitales qui captivent vos utilisateurs
            et boostent vos conversions. Notre approche allie recherche
            utilisateur, design thinking et prototypage itératif.
          </p>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Nos Services Design
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Target className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Audit UX
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Analyse heuristique
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Tests utilisateurs
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Recommandations d'amélioration
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Layout className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Prototypage Interactif
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Wireframes & Maquettes
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Prototypes cliquables
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Tests A/B
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Palette className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Design System
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Bibliothèque de composants
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Guide de style
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Documentation complète
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Users className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Tests Utilisateurs
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Sessions de test modérées
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Analyse comportementale
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Rapport d'insights
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Réalisations */}
      {/* <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Nos Projets Design
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-flowkraft-xl transition-shadow duration-300 border-2 border-gray-100">
              <div className="h-48 bg-gradient-to-r from-flowkraft-primary to-flowkraft-secondary flex items-center justify-center overflow-hidden">
                <img
                  src="/images/dev-web/354484.png"
                  alt="Redesign E-commerce"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Redesign E-commerce
                </h3>
                <p className="text-gray-600 mb-4">
                  Refonte complète de l'expérience utilisateur d'une plateforme e-commerce, augmentation de 35% du taux de conversion
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    UX Research
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    UI Design
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    Figma
                  </span>
                </div>
              </div>
            </div>

            
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-flowkraft-xl transition-shadow duration-300 border-2 border-gray-100">
              <div className="h-48 bg-gradient-to-r from-flowkraft-primary to-flowkraft-secondary flex items-center justify-center overflow-hidden">
                <img
                  src="/images/dev-mobile/654133.png"
                  alt="App Mobile Banking"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  App Mobile Banking
                </h3>
                <p className="text-gray-600 mb-4">
                  Design system complet et interface intuitive pour application bancaire mobile avec 4.8/5 de satisfaction utilisateur
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    Design System
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    Prototypage
                  </span>
                </div>
              </div>
            </div>

            
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-flowkraft-xl transition-shadow duration-300 border-2 border-gray-100">
              <div className="h-48 bg-gradient-to-r from-flowkraft-primary to-flowkraft-secondary flex items-center justify-center overflow-hidden">
                <img
                  src="/images/dev-web/7456982.png"
                  alt="Dashboard SaaS"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Dashboard SaaS
                </h3>
                <p className="text-gray-600 mb-4">
                  Interface de tableau de bord analytique avec data visualisation avancée et personnalisation utilisateur
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    UX/UI
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    Data Viz
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    Sketch
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="relative py-20 overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url(/images/main/2149755776.jpg)" }}
        ></div>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-flowkraft-primary to-black opacity-90"></div>

        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Créons ensemble une expérience mémorable
          </h2>
          <Link
            to="/#contact"
            className="inline-block bg-white text-flowkraft-primary px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Discuter de votre projet
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DesignUXUI;
